/* BMM Autosports - theme interactions */
(function () {
  'use strict';

  function initMobileNav() {
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  function initFacets() {
    var toggle = document.querySelector('[data-facets-toggle]');
    var facets = document.querySelector('[data-facets]');
    if (!toggle || !facets) return;
    toggle.addEventListener('click', function () {
      facets.classList.toggle('open');
    });
    var form = facets.querySelector('form');
    if (form) {
      facets.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () { form.submit(); });
      });
    }
  }

  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  function initGallery() {
    var main = document.querySelector('[data-main-img]');
    if (!main) return;
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full || t.src;
      });
    });
  }

  function initVariantForms() {
    var productJsonPromise = null;

    function normalize(value) {
      return String(value || '').trim();
    }

    function getAnalyticsProduct() {
      return (((window.ShopifyAnalytics || {}).meta || {}).product || {});
    }

    function getAnalyticsVariants() {
      return getAnalyticsProduct().variants || [];
    }

    function getCurrency() {
      return ((window.ShopifyAnalytics || {}).meta || {}).currency || (window.Shopify || {}).currency && window.Shopify.currency.active || 'USD';
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: getCurrency()
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function getSelectedTitle(form) {
      return Array.prototype.slice.call(form.querySelectorAll('select[name^="options["]'))
        .map(function (select) { return normalize(select.value); })
        .filter(Boolean)
        .join(' / ');
    }

    function titleFromVariantName(name) {
      return normalize(name).split(' - ').pop();
    }

    function findVariantByTitle(variants, title) {
      return variants.find(function (variant) {
        return normalize(variant.public_title || variant.title) === title || titleFromVariantName(variant.name) === title;
      }) || null;
    }

    function findAnalyticsVariant(form) {
      var selectedTitle = getSelectedTitle(form);
      if (!selectedTitle) return null;
      return findVariantByTitle(getAnalyticsVariants(), selectedTitle);
    }

    function readPaymentTermsMeta(form) {
      var paymentTerms = form.querySelector('shopify-payment-terms');
      if (!paymentTerms) return null;
      try {
        return JSON.parse(paymentTerms.getAttribute('shopify-meta') || 'null');
      } catch (error) {
        return null;
      }
    }

    function findPaymentTermsVariant(form, variantId) {
      var meta = readPaymentTermsMeta(form);
      var variants = meta && meta.variants ? meta.variants : [];
      return variants.find(function (variant) { return String(variant.id) === String(variantId); }) || null;
    }

    function loadProductJson() {
      if (!productJsonPromise) {
        productJsonPromise = fetch(window.location.pathname + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      }
      return productJsonPromise;
    }

    function updatePrice(form, analyticsVariant, productVariant) {
      var priceWrap = document.querySelector('.product__price');
      if (!priceWrap || !analyticsVariant) return;

      var priceEl = priceWrap.querySelector('span:not(.was)') || priceWrap.querySelector('span');
      var compareEl = priceWrap.querySelector('.was');
      var paymentVariant = findPaymentTermsVariant(form, analyticsVariant.id);
      var priceText = paymentVariant && paymentVariant.full_price ? paymentVariant.full_price : formatMoney(productVariant && productVariant.price != null ? productVariant.price : analyticsVariant.price);

      if (priceEl) priceEl.textContent = priceText;

      if (compareEl) {
        if (productVariant && productVariant.compare_at_price && productVariant.compare_at_price > productVariant.price) {
          compareEl.textContent = formatMoney(productVariant.compare_at_price);
          compareEl.hidden = false;
          if (priceEl) priceEl.style.color = 'var(--accent)';
        } else {
          compareEl.hidden = true;
          if (priceEl) priceEl.style.color = '';
        }
      }
    }

    function updateProductMeta(analyticsVariant, productVariant) {
      document.querySelectorAll('.product-meta div').forEach(function (row) {
        var text = normalize(row.textContent);
        var value = row.querySelector('span');
        if (!value) return;
        if (text.indexOf('SKU:') === 0) {
          value.textContent = analyticsVariant && analyticsVariant.sku ? analyticsVariant.sku : '-';
        }
        if (text.indexOf('Availability:') === 0) {
          var available = productVariant ? productVariant.available : true;
          value.textContent = available ? 'In stock' : 'Out of stock';
        }
      });
    }

    function updateButton(form, productVariant) {
      var button = form.querySelector('button[name="add"], button[type="submit"]');
      if (!button || !productVariant) return;
      button.disabled = !productVariant.available;
      button.textContent = productVariant.available ? 'Add to cart' : 'Sold out';
    }

    function updateUrl(variantId) {
      if (!variantId || !window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    }

    function updateProductForm(form) {
      if (!form) return;
      var analyticsVariant = findAnalyticsVariant(form);
      var idInput = form.querySelector('[name="id"]');
      if (!analyticsVariant || !idInput) return;

      idInput.value = String(analyticsVariant.id);

      var paymentTerms = form.querySelector('shopify-payment-terms');
      if (paymentTerms) {
        paymentTerms.setAttribute('variant-id', String(analyticsVariant.id));
      }

      updatePrice(form, analyticsVariant, null);
      updateProductMeta(analyticsVariant, null);
      updateUrl(analyticsVariant.id);

      loadProductJson().then(function (product) {
        var selectedTitle = getSelectedTitle(form);
        var productVariant = product && product.variants ? findVariantByTitle(product.variants, selectedTitle) : null;
        updatePrice(form, analyticsVariant, productVariant);
        updateProductMeta(analyticsVariant, productVariant);
        updateButton(form, productVariant);
      });
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('select[name^="options["]').forEach(function (select) {
        select.addEventListener('change', function () { updateProductForm(form); });
      });
      form.addEventListener('submit', function () { updateProductForm(form); }, true);
      updateProductForm(form);
    });
  }

  function refreshCart() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFacets();
    initSort();
    initGallery();
    initVariantForms();
    refreshCart();
  });
})();
